import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=29e9294f&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29e9294f')) {
      api.createRecord('29e9294f', component.options)
    } else {
      api.reload('29e9294f', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=29e9294f&", function () {
      api.rerender('29e9294f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/Sidebar.vue"
export default component.exports